'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TimelineDot = require('./TimelineDot');

var _TimelineDot2 = _interopRequireDefault(_TimelineDot);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The markup Information for all the events on the horizontal timeline.
 *
 * @param  {object} props The props from parent mainly styles
 * @return {StatelessFunctionalReactComponent} Markup Information for the fader
 */
var EventsBar = function EventsBar(_ref) {
  var events = _ref.events,
      selectedIndex = _ref.selectedIndex,
      styles = _ref.styles,
      handleDateClick = _ref.handleDateClick,
      labelWidth = _ref.labelWidth;
  return _react2.default.createElement(
    'ol',
    {
      className: 'events-bar',
      style: {
        listStyle: 'none'
      }
    },
    events.map(function (event, index) {
      return _react2.default.createElement(_TimelineDot2.default, {
        distanceFromOrigin: event.distance,
        label: event.label,
        date: event.date,
        index: index,
        key: index,
        onClick: handleDateClick,
        selected: selectedIndex,
        styles: styles,
        labelWidth: labelWidth
      });
    })
  );
};

/**
 * The styles that parent will provide
 * @type {Object}
 */
EventsBar.propTypes = {
  // Array containing the events
  events: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    distance: _propTypes2.default.number.isRequired,
    label: _propTypes2.default.string.isRequired,
    date: _propTypes2.default.string.isRequired
  })).isRequired,
  // The index of the selected event
  selectedIndex: _propTypes2.default.number,
  // a handler for clicks on a datapoint
  handleDateClick: _propTypes2.default.func,
  // The width you want the labels to be
  labelWidth: _propTypes2.default.number.isRequired,
  // Custom styling
  styles: _propTypes2.default.object
};

exports.default = EventsBar;


//////////////////
// WEBPACK FOOTER
// ../react-template/lib/components/timeline/react-horizontal-timeline/Components/Events.js
// module id = 1146
// module chunks = 0